// extracted by mini-css-extract-plugin
export default {"AddressForm":"Booking_AddressForm__7s-H4","AddressTile":"Booking_AddressTile__rFaXo"};